/* eslint-env browser */
import { marked } from 'marked';
import hljs from 'highlight.js';
/**
 * Configure marked with syntax highlighting
 */
marked.setOptions({
    breaks: true, // Convert \n to <br>
    gfm: true, // GitHub Flavored Markdown
});
// Custom renderer for code blocks with syntax highlighting
const renderer = {
    code({ text, lang, }) {
        if (lang && hljs.getLanguage(lang)) {
            try {
                const highlighted = hljs.highlight(text, { language: lang }).value;
                return `<pre><code class="hljs language-${lang}">${highlighted}</code></pre>`;
            }
            catch (err) {
                console.error('Highlight error:', err);
            }
        }
        const highlighted = hljs.highlightAuto(text).value;
        return `<pre><code class="hljs">${highlighted}</code></pre>`;
    },
};
marked.use({ renderer });
/**
 * Render markdown to HTML with syntax highlighting and copy buttons
 */
export function renderMarkdown(text) {
    if (!text)
        return '';
    // Render markdown
    const html = marked.parse(text);
    // Add copy buttons to code blocks
    return addCopyButtonsToCodeBlocks(html);
}
/**
 * Add copy buttons to all code blocks
 */
function addCopyButtonsToCodeBlocks(html) {
    // Wrap each <pre><code> block with a container and add copy button
    return html.replace(/<pre><code([^>]*)>([\s\S]*?)<\/code><\/pre>/g, (match, attributes, code) => {
        // Strip highlight spans and decode HTML entities to get plain code
        const decodedCode = stripHtmlTags(code);
        return `
        <div class="balancy-code-block-wrapper">
          <button class="balancy-code-copy-btn" data-code="${escapeAttribute(decodedCode)}" title="Copy code">
            <svg class="balancy-copy-icon" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <rect x="5" y="5" width="9" height="9" rx="1" stroke="currentColor" stroke-width="1.5"/>
              <path d="M3 10V3C3 2.44772 3.44772 2 4 2H10" stroke="currentColor" stroke-width="1.5"/>
            </svg>
            <svg class="balancy-copied-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" style="display: none;">
              <path d="M13 4L6 11L3 8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
          <pre><code${attributes}>${code}</code></pre>
        </div>
      `;
    });
}
/**
 * Escape attribute value for data attribute
 */
function escapeAttribute(text) {
    return text
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}
/**
 * Strip HTML tags and decode entities to get plain text
 */
function stripHtmlTags(html) {
    const div = document.createElement('div');
    div.innerHTML = html;
    return div.textContent || '';
}
/**
 * Initialize copy button functionality
 * Call this after rendering markdown to attach event listeners
 */
export function initializeCopyButtons(container) {
    const copyButtons = container.querySelectorAll('.balancy-code-copy-btn');
    copyButtons.forEach((button) => {
        button.addEventListener('click', async (e) => {
            e.preventDefault();
            e.stopPropagation();
            const btn = button;
            const code = btn.getAttribute('data-code');
            if (!code)
                return;
            try {
                // Copy to clipboard
                await navigator.clipboard.writeText(code);
                // Show success feedback
                const copyIcon = btn.querySelector('.balancy-copy-icon');
                const copiedIcon = btn.querySelector('.balancy-copied-icon');
                if (copyIcon && copiedIcon) {
                    copyIcon.style.display = 'none';
                    copiedIcon.style.display = 'block';
                    btn.classList.add('copied');
                    // Reset after 2 seconds
                    setTimeout(() => {
                        copyIcon.style.display = 'block';
                        copiedIcon.style.display = 'none';
                        btn.classList.remove('copied');
                    }, 2000);
                }
            }
            catch (err) {
                console.error('Failed to copy code:', err);
            }
        });
    });
}
